import React, { FunctionComponent } from "react";

export const Gray: FunctionComponent = ({ children }) => (
    <span className="char__gray">{children}</span>
);
